import React, { useEffect, useState } from "react";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../store/stateFunctions";
import { FaListAlt, FaFileExport } from "react-icons/fa";
import { CiClock1 } from "react-icons/ci";
import { MdOutlineDone } from "react-icons/md";
import { CgDanger } from "react-icons/cg";
import { NavLink } from "react-router-dom";
import Graphdashboard from "../Administration/GraphDashboard";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Dashboard = () => {
  const [dashboard, setDashboard] = useState([]);
  const [navratri, setnavratri] = useState([]);
  const [shivjayanti, setShivjayanti] = useState([]);
  const [ajayanti, setajayanti] = useState([]);
  const [other, setOther] = useState([]);
  const [table, setTable] = useState([]);
const [divisionalTable, setDivisionalTable] = useState([]);
const [policeTable, setPoliceTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [festivalName, setFestivalName] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState(null);
  const user = useSelectAccess("Super Admin");

  useEffect(() => {
    getDashboard();
    getNavratriDashboard();
    getshivjayantiDashboard();
    getajayantiDashboard();
    getOther();
    getTable();
  }, []);

  const getDashboard = () => {
    server
      .get("/dashboard/ganeshutsav", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response 1", response.data);
        setDashboard(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        handleApiError(error);
      });
  };

  const getNavratriDashboard = () => {
    server
      .get("/dashboard/navratri", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response 1", response.data);
        setnavratri(response.data);
      })
      .catch(function (error) {
        handleApiError(error);
      });
  };

  const getshivjayantiDashboard = () => {
    server
      .get("/dashboard/shiv_jayanti", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response 1", response.data);
        setShivjayanti(response.data);
      })
      .catch(function (error) {
        handleApiError(error);
      });
  };

  const getajayantiDashboard = () => {
    server
      .get("/dashboard/ambedkarjayanti", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response 1", response.data);
        setajayanti(response.data);
      })
      .catch(function (error) {
        handleApiError(error);
      });
  };

  const getOther = () => {
    server
      .get("/dashboard/other", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response 1", response.data);
        setOther(response.data);
      })
      .catch(function (error) {
        handleApiError(error);
      });
  };

  const getTable = () => {
  server
    .get("/dashboard/dashboard", {
      headers: {
        "Content-Type": "application/json",
        Authorization: user.authToken,
      },
    })
    .then(function (response) {
      console.log("api response 1", response.data);

      // फक्त departmentSummary दाखवायचं असेल
      // setTable(response.data.departmentSummary);

      // 👉 जर तिन्ही merge करायचं असेल तर
      setTable([
        ...response.data.departmentSummary,
        ...response.data.divisionalSummary,
        ...response.data.policeSummary,
      ]);
    })
    .catch(function (error) {
      handleApiError(error);
    });
};


const applyFilter = () => {
  server
    .get("/dashboard/dashboard/filter", {
      headers: {
        "Content-Type": "application/json",
        Authorization: user.authToken,
      },
      params: {
        fromDate,
        toDate,
        festival_name: festivalName,
      },
    })
    .then((response) => {
      console.log("api filter response", response.data);

      // 👉 तिन्ही summary merge करून एकच table बनवलं
     setTable([
        ...response.data.departmentSummary,
        ...response.data.divisionalSummary,
        ...response.data.policeSummary,
      ]);

      const festivalSummary = response.data.festivalSummary;

      const ganesh = festivalSummary.find((f) => f.name === "Ganesh Utsav");
      const navratri = festivalSummary.find((f) => f.name === "Navratri");
      const shivjayanti = festivalSummary.find((f) => f.name === "Shiv Jayanti");
      const ambedkar = festivalSummary.find((f) => f.name === "Ambedkar Jayanti");
      const other = festivalSummary.find((f) => f.name === "Other");

      setDashboard(ganesh);
      setnavratri(navratri);
      setShivjayanti(shivjayanti);
      setajayanti(ambedkar);
      setOther(other);

      toast.success("Filter applied successfully!");
    })
    .catch(handleApiError);
};




  const fetchReport = async () => {
    setExportLoading(true);
    setError(null);

    // Debug logging
    console.log("🚀 Starting report fetch...");
    console.log("📅 From Date:", fromDate);
    console.log("📅 To Date:", toDate);
    console.log("🎭 Festival Name:", festivalName);
    console.log("🔑 Auth Token:", user.authToken ? "Present" : "Missing");

    try {
      // FIXED: Send null instead of empty strings
      const requestPayload = {
        fromDate: fromDate && fromDate.trim() !== "" ? fromDate : null,
        toDate: toDate && toDate.trim() !== "" ? toDate : null,
        festival_name:
          festivalName && festivalName.trim() !== "" ? festivalName : null,
      };

      console.log("📤 Request payload:", requestPayload);

      const response = await server.post(
        "/user_appl/report/overviewDate",
        requestPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        }
      );

      console.log("✅ API Response Status:", response.status);
      console.log("✅ API Response Data:", response.data);

      setReportData(response.data);

      // Check if we have valid data structure
      if (response.data && response.data.status === 200) {
        const { departmentSummary, divisionalSummary, policeSummary } =
          response.data;

        // Check if any data exists
        const hasData =
          (departmentSummary && departmentSummary.length > 0) ||
          (divisionalSummary && divisionalSummary.length > 0) ||
          (policeSummary && policeSummary.length > 0);

        if (hasData) {
          generatePDFReport(response.data);
        } else {
          console.warn("⚠️ No data found in any summary");
          setError("No data available for the selected filters");
          toast.warning("No data found for the selected filters");
        }
      } else {
        console.warn("⚠️ Unexpected response structure");
        setError("Invalid response format from server");
        toast.error("Invalid response format from server");
      }
    } catch (err) {
      console.error("❌ Full error object:", err);
      console.error("❌ Error message:", err.message);
      console.error("❌ Error response:", err.response);

      let errorMessage = "Failed to fetch report data";

      if (err.response) {
        console.error("❌ Response status:", err.response.status);
        console.error("❌ Response data:", err.response.data);

        if (err.response.status === 401) {
          errorMessage = "Authentication failed. Please login again.";
        } else if (err.response.status === 403) {
          errorMessage = "Access denied. Insufficient permissions.";
        } else if (err.response.status === 404) {
          errorMessage = "Report endpoint not found. Please contact support.";
        } else if (err.response.status === 500) {
          errorMessage =
            err.response.data?.error || "Server error. Please try again later.";
        } else if (err.response.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.data?.error) {
          errorMessage = err.response.data.error;
        }
      } else if (err.request) {
        console.error("❌ Network error - no response received");
        errorMessage = "Network error. Please check your internet connection.";
      } else {
        console.error("❌ Request setup error:", err.message);
        errorMessage = `Request error: ${err.message}`;
      }

      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setExportLoading(false);
    }
  };

  const generatePDFReport = (data) => {
    try {
      console.log("📄 Starting PDF generation with data:", data);

      const doc = new jsPDF("p", "mm", "a4");

      if (typeof doc.autoTable !== "function") {
        console.error("❌ autoTable is not available on jsPDF instance");
        toast.error("PDF plugin not loaded properly");
        setError("autoTable plugin not loaded");
        return;
      }

      // ======================
      // HEADER WITH LOGO
      // ======================
      const pageWidth = doc.internal.pageSize.getWidth();

      // Add logo

      doc.addImage("/logoBase64.jpeg", "JPEG", 15, 10, 25, 25);

      // Title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.setTextColor(44, 62, 80);
      doc.text("Applications Overview Report", pageWidth / 2, 20, {
        align: "center",
      });

      // Subtitle line
      doc.setFontSize(12);
      doc.setTextColor(100, 100, 100);
      const filters = data.filters || {};
      const dateRange = `Report Period: ${filters.fromDate || "N/A"} to ${
        filters.toDate || "N/A"
      }`;
      doc.text(dateRange, pageWidth / 2, 28, { align: "center" });

      const now = new Date();

      // Date
      const currentDate = now.toLocaleDateString("en-IN");

      // Time in 12-hour format with AM/PM
      const currentTime = now.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      // Show both
      doc.text(
        `Generated on: ${currentDate} ${currentTime}`,
        pageWidth / 2,
        34,
        {
          align: "center",
        }
      );

      // ======================
      // TABLE DATA
      // ======================
      let tableBody = [];

      // Department Summary
      if (data?.departmentSummary?.length > 0) {
        data.departmentSummary.forEach((arr) => {
          const dept = arr[0];
          tableBody.push([
            dept.name || "N/A",
            dept.total || "0",
            dept.pending || "0",
            dept.approved || "0",
            dept.rejected || "0",
          ]);
        });
      }

      // Divisional Department
      tableBody.push([
        {
          content: "Divisional Department",
          colSpan: 5,
          styles: {
            halign: "left",
            fillColor: [230, 230, 250],
            fontStyle: "bold",
            textColor: [44, 62, 80],
          },
        },
      ]);

      const manualDivisions = [
        { key: "Zendigate Division", index: 0 },
        { key: "Burudgaon Division", index: 1 },
        { key: "Vasuli Division", index: 2 },
        { key: "Savedi Division", index: 3 },
      ];
      manualDivisions.forEach((div) => {
        const apiData = data?.divisionalSummary?.[div.index] || {};
        tableBody.push([
          div.key,
          apiData.total || "0",
          apiData.pending || "0",
          apiData.approved || "0",
          apiData.rejected || "0",
        ]);
      });

      // Police Department
      tableBody.push([
        {
          content: "Police Department",
          colSpan: 5,
          styles: {
            halign: "left",
            fillColor: [230, 230, 250],
            fontStyle: "bold",
            textColor: [44, 62, 80],
          },
        },
      ]);

      const manualPolice = [
        { key: "MIDC Police Department", index: 0 },
        { key: "Kotwali Police Department", index: 1 },
        { key: "Tofkhana Police Department", index: 2 },
        { key: "Bhingar Camp Police Department", index: 3 },
      ];
      manualPolice.forEach((police) => {
        const apiData = data?.policeSummary?.[police.index] || {};
        tableBody.push([
          police.key,
          apiData.total || "0",
          apiData.pending || "0",
          apiData.approved || "0",
          apiData.rejected || "0",
        ]);
      });

      // ======================
      // TABLE RENDER
      // ======================
      doc.autoTable({
        head: [
          [
            "Department",
            "Total Applications",
            "Pending",
            "Approved",
            "Rejected",
          ],
        ],
        body: tableBody,
        startY: 45,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 4,
          valign: "middle",
        },
        headStyles: {
          fillColor: [41, 128, 185], // professional blue
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          textColor: [44, 62, 80],
        },
        columnStyles: {
          0: { halign: "left", cellWidth: 70 },
          1: { halign: "center" },
          2: { halign: "center" },
          3: { halign: "center" },
          4: { halign: "center" },
        },
        didDrawPage: (data) => {
          // Footer
          const pageHeight = doc.internal.pageSize.getHeight();
          doc.setFontSize(9);
          doc.setTextColor(150);
          doc.text(
            "Confidential - Internal Use Only",
            pageWidth / 2,
            pageHeight - 10,
            { align: "center" }
          );
        },
      });

      // ======================
      // SAVE
      // ======================
      const fileName = `Applications_Report_${
        filters.fromDate || "default"
      }_to_${filters.toDate || "today"}_${new Date().getTime()}.pdf`;
      doc.save(fileName);

      console.log("✅ PDF generated successfully:", fileName);
      toast.success("PDF report generated successfully!");
    } catch (error) {
      console.error("❌ Error generating PDF:", error);
      if (error.message.includes("autoTable")) {
        toast.error("PDF plugin loading error. Please refresh and try again.");
        setError("autoTable plugin error: " + error.message);
      } else {
        toast.error("Failed to generate PDF report");
        setError("PDF generation failed: " + error.message);
      }
    }
  };

  // Enhanced error handling function
  const handleApiError = (error) => {
    console.error("API Error:", error);

    if (error instanceof AxiosError && error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error.response?.data?.error) {
      toast.error(error.response.data.error);
    } else if (error.response?.status === 401) {
      toast.error("Authentication failed. Please login again.");
    } else if (error.response?.status === 403) {
      toast.error("Access denied. Insufficient permissions.");
    } else if (error.response?.status === 404) {
      toast.error("Endpoint not found. Please contact support.");
    } else if (error.response?.status >= 500) {
      toast.error("Server error. Please try again later.");
    } else {
      toast.error("Failed to connect to server");
    }
  };

  // Test connection function
  const testConnection = () => {
    console.log("🧪 Testing connection...");
    console.log("Auth Token:", user.authToken ? "✅ Present" : "❌ Missing");
    console.log(
      "From Date:",
      fromDate || "❌ Not set (will use backend default: 2025-08-11)"
    );
    console.log(
      "To Date:",
      toDate || "❌ Not set (will use backend default: today)"
    );
    console.log(
      "Festival Name:",
      festivalName || "❌ Not set (no festival filter)"
    );
    console.log("Server config:", server.defaults);

    // Test the exact endpoint
    console.log("🌐 Testing endpoint: /user_appl/report/overviewDate");
    console.log("📤 Will send payload:", {
      fromDate: fromDate || null,
      toDate: toDate || null,
      festival_name: festivalName || null,
    });

    toast.info("Check console for connection details");
  };

  // Festival Card Component
  const FestivalCard = ({ title, data, bgColor, textColor }) => {
    return (
      <div className="card mb-4 shadow border-0">
        <div className={`card-header ${bgColor} ${textColor} py-3`}>
          <h5 className="mb-0 fw-bold">{title}</h5>
        </div>
        <div className="card-body">
          <div className="row g-4">
            <div className="col-md-3 col-6">
              <NavLink className="text-decoration-none">
                <div className="text-center p-3 rounded bg-light h-100">
                  <FaListAlt className="display-5 text-primary mb-3" />
                  <h2 className="fw-bold text-primary">
                    {data.totalAppl || 0}
                  </h2>
                  <p className="text-muted mb-0">Total Applications</p>
                </div>
              </NavLink>
            </div>

            <div className="col-md-3 col-6">
              <div className="text-center p-3 rounded bg-light h-100">
                <CiClock1 className="display-5 text-warning mb-3" />
                <h2 className="fw-bold text-warning">
                  {data.pendingAppl || 0}
                </h2>
                <p className="text-muted mb-0">Pending Applications</p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <NavLink className="text-decoration-none">
                <div className="text-center p-3 rounded bg-light h-100">
                  <MdOutlineDone className="display-5 text-success mb-3" />
                  <h2 className="fw-bold text-success">
                    {data.approvedAppl || 0}
                  </h2>
                  <p className="text-muted mb-0">Approved Applications</p>
                </div>
              </NavLink>
            </div>

            <div className="col-md-3 col-6">
              <div className="text-center p-3 rounded bg-light h-100">
                <CgDanger className="display-5 text-danger mb-3" />
                <h2 className="fw-bold text-danger">
                  {data.rejectedAppl || 0}
                </h2>
                <p className="text-muted mb-0">Rejected Applications</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "300px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid py-4 bg-light">
        <div className="container">
          {/* Dashboard Header */}
          <div className="row mb-4">
            <div className="col">
              <h1 className="display-5 fw-bold text-dark mb-1">
                Applications Dashboard
              </h1>
              <p className="lead text-muted">
                Festival applications management system
              </p>
            </div>
          </div>

          <div className="card mb-4 shadow border-0">
            <div className="card-body">
              <div className="row g-3 align-items-end">
                <div className="col-lg-2 col-md-3">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  {/* <small className="text-muted">Default: 2025-08-11</small> */}
                </div>
                <div className="col-lg-2 col-md-3">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  {/* <small className="text-muted">Default: Today</small> */}
                </div>
                <div className="col-lg-2 col-md-3">
                  <label className="form-label">Festival Name</label>
                  <select
                    className="form-control"
                    value={festivalName}
                    onChange={(e) => setFestivalName(e.target.value)}
                  >
                    <option value="">All Festivals</option>
                    <option value="ganesh_utsav">Ganesh Utsav</option>
                    <option value="navratri">Navratri</option>
                    <option value="shiv_jayanti">Shiv Jayanti</option>
                    <option value="ambedkar_jayanti">Ambedkar Jayanti</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="col-lg-2 col-md-3">
                  <button
                    className="btn btn-primary w-100"
                    onClick={applyFilter}
                  >
                    Apply Filter
                  </button>
                </div>
                <div className="col-lg-2 col-md-6">
                  <button
                    className="btn btn-success w-100 d-flex align-items-center justify-content-center gap-2"
                    onClick={fetchReport}
                    disabled={exportLoading}
                  >
                    {exportLoading ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <FaFileExport />
                    )}
                    Export PDF
                  </button>
                </div>
                {/* <div className="col-lg-2 col-md-6">
                  <button
                    className="btn btn-info w-100"
                    onClick={testConnection}
                  >
                    Test Debug
                  </button>
                </div> */}
              </div>

              {/* Enhanced Error Display */}
              {error && (
                <div
                  className="alert alert-danger alert-dismissible fade show mt-3"
                  role="alert"
                >
                  <strong>Error:</strong> {error}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setError(null)}
                    aria-label="Close"
                  ></button>
                </div>
              )}

              {/* Info about defaults */}
              <div className="alert alert-info mt-3">
                <strong>Info:</strong> Select From Date and To Date then click on Export PDF to generate report.
              </div>

              {/* Debug Info */}
              {/* {process.env.NODE_ENV === "development" && (
                <div className="alert alert-secondary mt-3">
                  <small>
                    <strong>Debug Info:</strong>
                    From: {fromDate || "Backend default (2025-08-11)"} | To:{" "}
                    {toDate || "Backend default (Today)"} | Festival:{" "}
                    {festivalName || "All"} | Token:{" "}
                    {user.authToken ? "Present" : "Missing"}
                  </small>
                </div>
              )} */}
            </div>
          </div>

          {/* Department Status Table */}
          <div className="card shadow mb-5 border-0">
  <div className="card-header bg-info text-white py-3">
    <h5 className="mb-0 fw-bold">Total Applications Status</h5>
  </div>
  <div className="card-body p-0">
    <div className="table-responsive">
      <table className="table table-hover align-middle mb-0">
        <thead className="bg-light">
          <tr>
            <th className="text-dark ps-4">Department</th>
            <th className="text-center">Total</th> {/* New Column */}
            <th className="text-center text-success">Approved</th>
            <th className="text-center text-warning">Pending</th>
            <th className="text-center text-danger">Rejected</th>
          </tr>
        </thead>
        <tbody>
          {table?.map((item, index) => {
            return (
              <tr key={index}>
                <td className="fw-bold ps-4">
                  {item.name === "PWD" ? "MSEDCL" : item.name}
                </td>
                <td className="text-center fw-bold">{item.total}</td> {/* Total value */}
                <td className="text-center text-success fw-bold">
                  {item.approved}
                </td>
                <td className="text-center text-warning fw-bold">
                  {item.pending}
                </td>
                <td className="text-center text-danger fw-bold">
                  {item.rejected}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>


          {/* Festival Cards */}
          <FestivalCard
            title="गणेश उत्सव"
            data={dashboard}
            bgColor="bg-warning"
            textColor="text-white"
          />

          <FestivalCard
            title="नवरात्री उत्सव"
            data={navratri}
            bgColor="bg-danger"
            textColor="text-white"
          />

          <FestivalCard
            title="छत्रपती शिवाजी महाराज जयंती"
            data={shivjayanti}
            bgColor="bg-success"
            textColor="text-white"
          />

          <FestivalCard
            title="डॉ. बाबासाहेब आंबेडकर जयंती"
            data={ajayanti}
            bgColor="bg-info"
            textColor="text-white"
          />

          <FestivalCard
            title="Other"
            data={other}
            bgColor="bg-dark"
            textColor="text-white"
          />
        </div>
      </div>

      {/* Graph Dashboard */}
      <Graphdashboard role="Super Admin" />
    </>
  );
};

export default Dashboard;
